import React from "react";
const IconRadioUnselectable = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 10C3 6.13401 6.13401 3 10 3C11.162 3 12.2556 3.28239 13.2182 3.78178L14.6855 2.3145C14.6244 2.27717 14.5628 2.24055 14.5007 2.20465C13.1759 1.4383 11.6376 1 10 1C5.02944 1 1 5.02944 1 10C1 11.6376 1.4383 13.1759 2.20465 14.5007C2.24055 14.5628 2.27717 14.6244 2.3145 14.6855L3.78178 13.2182C3.28239 12.2556 3 11.162 3 10ZM6.78178 16.2182L5.3145 17.6855C5.37562 17.7228 5.43721 17.7594 5.49927 17.7953C6.82407 18.5617 8.36237 19 10 19C14.9706 19 19 14.9706 19 10C19 8.36237 18.5617 6.82407 17.7953 5.49927C17.7594 5.43721 17.7228 5.37562 17.6855 5.3145L16.2182 6.78178C16.7176 7.74443 17 8.83798 17 10C17 13.866 13.866 17 10 17C8.83798 17 7.74443 16.7176 6.78178 16.2182Z"
      fill="currentColor"
    />
    <path d="M16 4L4 16" stroke="currentColor" strokeWidth="2" strokeLinecap="square" strokeLinejoin="round" />
  </svg>
);
export default IconRadioUnselectable;
